<template>
  <div class="login">
    <header class="page-header">
      <van-row style="width: 100%;">
        <van-col span="2"></van-col>
        <van-col span="16">{{ $t('Login.欢迎登录') }} {{ title }}</van-col>
        <van-col span="6">
          <van-dropdown-menu active-color="#1989fa" style="width: 100%; ">
            <van-dropdown-item
              v-model="lang"
              :options="option1"
              @change="onLangChange"
            />
          </van-dropdown-menu>
        </van-col>
      </van-row>
    </header>
    <main class="page-body">
      <div class="label">{{ $t('Login.ncp8ml') }}</div>
      <van-field
        v-model="username"
        clearable
        :placeholder="$t('Login.vueVLyW-zKejH444LZGT9y6-')"
      ></van-field>
      <div class="label">{{ $t('Login.nmoky3') }}</div>
      <van-field
        v-model="password"
        :type="showPassword ? 'input' : 'password'"
        :placeholder="$t('Login.vuenM-iO4iRRW4Iq6WCnSsPg')"
      >
        <template #right-icon>
          <van-icon
            :name="showPassword ? 'closed-eye' : 'eye-o'"
            @click="showPassword = !showPassword"
          />
        </template>
      </van-field>
      <div class="forget" @click="$router.push({ name: 'ResetPassword' })">
        {{ $t('Login.vue6Yn-B5G16XjDz25117JSV') }}
      </div>
      <van-button type="info" @click="onLogin" :disabled="!valid">
        {{ $t('Login.vue-lHuUIdhEZT6h3Q8Lrgnp') }}
      </van-button>
      <div class="sign-up x-center">
        <span>{{ $t('Login.vueygJSbYR_JprUZ8Rt8eCcA') }}</span>
        <router-link class="theme-color" :to="{ name: 'SignUp' }">
          {{ $t('Login.vueTheZurgOX1AAHawZITosf') }}
        </router-link>
        <router-link
          class="theme-color"
          style="padding-left: 10px"
          :to="{ name: 'Home' }"
        >
          {{ $t('Login.返回主页') }}
        </router-link>
      </div>
    </main>
  </div>
</template>
<script>
import { i18n } from '@/plugins/i18n';
import store from '@/store';
import { login } from '@/api/account.js';
import { APP_TITLE, BASE_URL } from '@/api/index.js';
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
export default {
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
      title: APP_TITLE,
      openid: '',
      lang: 'zh',
      option1: [
        { text: '简体', value: 'zh' },
        { text: '繁体', value: 'zhtw' },
        { text: 'En(US)', value: 'en' },
        { text: 'Arabic', value: 'ar' },
        { text: 'IDN', value: 'id' },
        { text: 'RU', value: 'ru' },
        { text: 'Bur(MY)', value: 'my' },
        { text: 'TR', value: 'tr' },
        { text: 'TKM', value: 'tkm' },
      ],
    };
  },
  computed: {
    valid() {
      return this.username && this.password;
    },
  },
  mounted() {
    if (store.getters.language == undefined) {
      // store.getters.language = 'zh';
      // i18n.locale = 'zh';
      var language = (
        navigator.browserLanguage || navigator.language
      ).toLowerCase();
      if (language.indexOf('zh-tw') > -1) {
        store.getters.language = 'zhtw';
        i18n.locale = 'zhtw';
        Locale.use('zh-CN', zhCN);
      } else if (language.indexOf('zh') > -1) {
        store.getters.language = 'zh';
        i18n.locale = 'zh';
        Locale.use('zh-CN', zhCN);
      } else if (language.indexOf('en') > -1) {
        store.getters.language = 'en';
        i18n.locale = 'en';
        Locale.use('en-US', enUS);
      } else if (language.indexOf('ru') > -1) {
        store.getters.language = 'ru';
        i18n.locale = 'ru';
        Locale.use('en-US', enUS);
      } else if (language.indexOf('ar') > -1) {
        store.getters.language = 'ar';
        i18n.locale = 'ar';
        Locale.use('en-US', enUS);
      } else if (language.indexOf('id') > -1) {
        store.getters.language = 'id';
        i18n.locale = 'id';
        Locale.use('en-US', enUS);
      } else if (language.indexOf('my') > -1) {
        store.getters.language = 'my';
        i18n.locale = 'my';
        Locale.use('en-US', enUS);
      } else if (language.indexOf('tr') > -1) {
        store.getters.language = 'tr';
        i18n.locale = 'tr';
        Locale.use('en-US', enUS);
      } else if (language.indexOf('tkm') > -1) {
        store.getters.language = 'tkm';
        i18n.locale = 'tkm';
        Locale.use('en-US', enUS);
      } else {
        store.getters.language = 'en';
        i18n.locale = 'en';
        Locale.use('en-US', enUS);
      }
    }
    console.log(store.getters.language);
    this.lang = store.getters.language;
    console.log(this.$route.query.openid);
    if (this.isWeiXin()) {
      var openid = this.$route.query.openid;
      if (openid == undefined || openid == null || openid == '') {
        location.href = BASE_URL + '/customer/RegWeiXinAuth';
      } else {
        this.data.openid = openid;
      }
    }
  },
  methods: {
    onLogin() {
      this.$toast.loading({
        duration: 0,
      });
      login({ username: this.username, password: this.password })
        .then(res => {
          this.$toast.clear();
          if (res.Result) {
            let token = res.DataDict['user'].sTeches;
            localStorage.setItem('token', token);
            localStorage.setItem('QSOA_LOGIN_STATUS', 1);
            this.$store.dispatch('getUserInfo');
            this.$router.replace({
              name: 'Home',
            });
          } else {
            this.$toast.fail(res.Info);
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    onLangChange(lang) {
      console.log(store.getters.language);
      store.getters.language = lang;
      i18n.locale = lang;
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return false;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.login {
  background-color: #fff;
}
.page-header {
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}
.page-body {
  padding: rem(60px);
}
.label {
  font-size: 16px;
  margin-bottom: rem(30px);
}
.van-field {
  border-radius: rem(25px);
  margin-bottom: rem(40px);
  background-color: #f7f7fc;
  font-size: 16px;
  padding-top: rem(24px);
  padding-bottom: rem(24px);
}
.forget {
  color: #9c9bb4;
  text-align: right;
}
.van-button {
  height: rem(100px);
  line-height: rem(100px);
  width: 100%;
  border-radius: rem(50px);
  margin-top: rem(156px);
  font-size: 16px;
}
.sign-up {
  color: #b2b2c4;
  margin-top: rem(212px);
}
/deep/.van-dropdown-menu__title {
  color: rgb(25, 137, 250);
}
</style>
